(function () {
  'use strict';
  function hf15Init() {
    var targets = document.querySelectorAll('.hf15-reveal');
    if (!targets.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('hf15-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1 });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('hf15-in'); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hf15Init);
  } else {
    hf15Init();
  }
}());